var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalStyleFooter, GlobalStyleFooterText } from '../styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTools } from '@fortawesome/pro-regular-svg-icons/faTools';
import { faPaintbrush } from '@fortawesome/pro-regular-svg-icons/faPaintbrush';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
var GlobalStyleMessages = function () {
    return (_jsxs(GlobalStyleFooter, { children: [_jsx(GlobalStyleFooterText, __assign({ muted: true }, { children: "You can always change this later in" })), _jsx(FontAwesomeIcon, { color: "#353535", size: "sm", icon: faTools }), ' ', _jsx(GlobalStyleFooterText, { children: "Settings" }), _jsx(FontAwesomeIcon, { color: "#828282", size: "sm", icon: faChevronRight }), ' ', _jsx(FontAwesomeIcon, { color: "#353535", size: "sm", icon: faPaintbrush }), ' ', _jsx(GlobalStyleFooterText, { children: "Styles" })] }));
};
export default GlobalStyleMessages;
